import React from "react";

import { useTheme, Statistics, IconPanel, Grid } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import Group from "@tiny/icons/generated/Group";
import IntegrationsOutline from "@tiny/icons/generated/IntegrationsOutline";
import UploadOutline from "@tiny/icons/generated/UploadOutline";
import { useTotalCustomerStatistics } from "./AudienceStats.hooks";

function AudienceStats() {
  const theme = useTheme();

  const { mdUp, lgUp } = useBreakpoints();

  const { totalSubscribers, totalIntegrations, totalManualUpload, isLoading } =
    useTotalCustomerStatistics();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12} md={4}>
        <IconPanel
          icon={<Group />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={isLoading ? "-" : totalSubscribers}
            title="Unique Customers"
            link="/main/audience/sources/all"
          />
        </IconPanel>
      </Grid>
      <Grid item xs={12} md={4}>
        <IconPanel
          icon={<IntegrationsOutline />}
          color={theme.palette.purple.dark}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={isLoading ? "-" : totalIntegrations}
            title="Integrations"
            info="Customers imported through integrations"
          />
        </IconPanel>
      </Grid>
      <Grid item xs={12} md={4}>
        <IconPanel
          icon={<UploadOutline />}
          color={theme.palette.blue.dark}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={isLoading ? "-" : totalManualUpload}
            title="Manual upload"
            info="Customers imported through manual upload"
          />
        </IconPanel>
      </Grid>
    </Grid>
  );
}

export default AudienceStats;
